//CSS
import "../../Components/Page/Page.css";
import "./TimeLine.css";

//React
import React from "react";
import SecHeader from "../../Components/SecHeader/SecHeader";
import SubSection from "../../Components/Section/SubSection";
import { faNewspaper } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import NewsReleases from "../../Components/Article/NewsReleases.json";
import Button2 from "../../Components/Button2/Button2";

interface TimelineText {
  headLine: string;
  text: string;
  readMore: string;
}

const Featured: React.FC = () => {
  return (
    <div className="sectionContainer">
      <SecHeader title="Featured Releases" />
      <SubSection isSplit={false}>
        <div className="description-container">
          <div className="news-header">
            <FontAwesomeIcon
              className="news-icon"
              icon={faNewspaper}
              size="2x"
            />
            <b className="news-title">
              {NewsReleases[4].publishedAt
                ? new Date(NewsReleases[4].publishedAt).toLocaleDateString(
                    "en-US",
                    {
                      month: "long",
                      year: "numeric",
                    },
                  )
                : null}{" "}
              - {NewsReleases[4].title}
            </b>
          </div>

          <p>{NewsReleases[4].excerpt}</p>
          <Button2
            name="readMore"
            text="Read more..."
            href={`/article/${NewsReleases[4].slug}`}
            classname="ctaButton"
          />
          <br />
        </div>
      </SubSection>
    </div>
  );
};

export default Featured;
